<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {onMount} from 'svelte';
    import {submit, validateInput, validateForm} from '../Form/utils.js';
    import yup, {object, string} from 'yup';
    import Spinner from '../Spinner.svelte';
    import Errors from '../Errors.svelte';
    import DuplicateCheckTextInput from '../DuplicateCheckTextInput.svelte'
    import TextInput from '../TextInput.svelte';
    import TagSelect from '../Tag/TagSelect.svelte';
    import ImageInput from './ImageInput.svelte';
    import {
        tool as toolStore,
    } from './store.js';
    import {sgettext} from '../../i18n.js';

    function initialFields() {
        return {
            id: '',
            description: '',
            image: null,
            tags: '',
            deleted: false
        }
    }

    export let specification = initialFields();
    let duplicateCheckApi = '';
    if ($toolStore.id)
        duplicateCheckApi = `${PATH_PREFIX}/sw/api/elements_database/globaltools/${$toolStore.id}/check_specification_duplicate/`;
    let duplicateCheckHardFail = false;

    let schema = object().shape({
        description: string()
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .test(
                sgettext("$$DUPLICATE_1$$"),
                sgettext("$$SPECIFICATION_NAME_ALREADY_EXISTS$$"),
                _ => {
                    // Check locally stored specifications to cover any possible duplicates in any unsaved specifications
                    for (let spec of $toolStore.specifications) {
                        if (!spec.deleted && spec.id !== specification.id && spec.description === specification.description) {
                            duplicateCheckHardFail = true;
                        }
                    }

                    return !duplicateCheckHardFail;
                },
            ),
    });

    let specificationDescriptionBeforeEdit = specification.description;

    let fieldIsValid = {
        description: {
            isValid: true,
            errors: ''
        },
    };

    let getTagsApi = `${PATH_PREFIX}/sw/api/elements_database/element_tags/`;
    let sending = false;
    let errors = null;

    function handleDuplicate(event) {

        duplicateCheckHardFail = false;

        if (event.detail.length) {
            if (event.detail[0].text !== specificationDescriptionBeforeEdit && event.detail[0].similarity === 100) {
                specification.isValid = false;
                specification.errors = sgettext('$$SPECIFICATION_NAME_ALREADY_EXISTS$$');
                duplicateCheckHardFail = true;
            }
        }
    }

    function handleTagChange() {
        specification.tags = specification.tags.map(t => t.name? t.name : t);
    }

    function handleImageRemoval() {
        specification.image = null;
    }

    async function handleImageChange(image) {
        image.id = specification.id;
        image.url = URL.createObjectURL(image);
        specification.image = image;
        $toolStore.specification_images = [...$toolStore.specification_images.filter(s => s.id != specification.id), image];
    }

    function handleDelete() {
        specification.deleted = !specification.deleted;
    }

    function resetForm() {
        specification = initialFields();
    }

    onMount(() => {
        const descriptionInput = document.getElementById('description');

        if (descriptionInput) {
            descriptionInput.focus();
        }
    });
</script>

<style>
    .inline-footer {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

</style>

<section class="container bg-gray-100 border mb-3 py-3">

    <div class="row">

        {#if specification.deleted}
            <div class="col align-self-center text-danger">{sgettext('$$TOOL_SPECIFICATION_DELETED$$')}</div>
        {:else}
            <div class="col-3">
                <label>{sgettext('$$TOOL_SPEC_IMAGE$$')}</label>
                <ImageInput
                    bind:media={specification.image}
                    width="160px"
                    height="90px"
                    onRemove={handleImageRemoval}
                    onChange={handleImageChange}
                />
            </div>
            <div class="col">
                <DuplicateCheckTextInput
                    id="description"
                    label={sgettext("$$TOOL_SPEC_NAME_1$$")}
                    multiline={false}
                    rows={1}
                    required={true}
                    apiurl={duplicateCheckApi}
                    bind:isValid={specification.isValid}
                    bind:errors={specification.errors}
                    bind:value={specification.description}
                    object={specification}
                    on:check={handleDuplicate}
                    placeholder='e.g. AF - 1-1/8 x 1-1/4"'
                    {schema}/>
            </div>
            <div class="col">
                <label>{sgettext('$$TOOL_SPEC_TAGS$$')}</label>
                <TagSelect
                        id={`specTags${specification.id}`}
                        bind:values={specification.tags}
                        extraStyle="height: 50px;"
                        filterKey="q"
                        optionsApiUrl={getTagsApi}
                        on:changed={handleTagChange}
                        allowNewOption={true}
                        maxSelection={10}/>
            </div>
        {/if}
        <div class="pr-2">
            {#if specification.deleted}
                <button type="button" class="btn btn-link text-secondary" on:click={handleDelete}>{sgettext('$$UNDO$$')}</button>
            {:else}
                <button type="button" class="btn btn-link text-secondary mt-4" on:click={handleDelete}><i class="fas fa5-trash-alt"></i></button>
            {/if}
        </div>
    </div>
    <div class="inline-footer">
    </div>
    {#if errors}
        <Errors {errors}/>
    {/if}
</section>
